import { jsx as m, jsxs as K } from "react/jsx-runtime";
import { forwardRef as z, useState as M, useEffect as te, useMemo as D, useCallback as ue, memo as le, useRef as Me, useImperativeHandle as Je } from "react";
import { c as F } from "./tw-cn-mXgPecoF.mjs";
import { o as Ye } from "./index-CcECYkhV.mjs";
import { c as Ze } from "./variance-DhhqoHkK.mjs";
import { u as Qe } from "./use-focus-BGKOEgog.mjs";
import { a as Re, b as B, r as w, i as L, f as ke, S as _e } from "./isObjectLike-BurtZzWI.mjs";
var V = Array.isArray, et = "[object AsyncFunction]", tt = "[object Function]", rt = "[object GeneratorFunction]", nt = "[object Proxy]";
function Fe(e) {
  if (!Re(e))
    return !1;
  var t = B(e);
  return t == tt || t == rt || t == et || t == nt;
}
var Z = w["__core-js_shared__"], ye = function() {
  var e = /[^.]+$/.exec(Z && Z.keys && Z.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function at(e) {
  return !!ye && ye in e;
}
var it = Function.prototype, st = it.toString;
function O(e) {
  if (e != null) {
    try {
      return st.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ot = /[\\^$.*+?()[\]{}|]/g, ut = /^\[object .+?Constructor\]$/, lt = Function.prototype, ft = Object.prototype, ct = lt.toString, dt = ft.hasOwnProperty, pt = RegExp(
  "^" + ct.call(dt).replace(ot, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function gt(e) {
  if (!Re(e) || at(e))
    return !1;
  var t = Fe(e) ? pt : ut;
  return t.test(O(e));
}
function ht(e, t) {
  return e == null ? void 0 : e[t];
}
function N(e, t) {
  var r = ht(e, t);
  return gt(r) ? r : void 0;
}
var re = N(w, "WeakMap"), _t = 9007199254740991, yt = /^(?:0|[1-9]\d*)$/;
function vt(e, t) {
  var r = typeof e;
  return t = t ?? _t, !!t && (r == "number" || r != "symbol" && yt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Le(e, t) {
  return e === t || e !== e && t !== t;
}
var bt = 9007199254740991;
function He(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= bt;
}
function mt(e) {
  return e != null && He(e.length) && !Fe(e);
}
var At = Object.prototype;
function Tt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || At;
  return e === r;
}
function xt(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var wt = "[object Arguments]";
function ve(e) {
  return L(e) && B(e) == wt;
}
var Ge = Object.prototype, St = Ge.hasOwnProperty, $t = Ge.propertyIsEnumerable, Et = ve(/* @__PURE__ */ function() {
  return arguments;
}()) ? ve : function(e) {
  return L(e) && St.call(e, "callee") && !$t.call(e, "callee");
};
function Ot() {
  return !1;
}
var ze = typeof exports == "object" && exports && !exports.nodeType && exports, be = ze && typeof module == "object" && module && !module.nodeType && module, Pt = be && be.exports === ze, me = Pt ? w.Buffer : void 0, jt = me ? me.isBuffer : void 0, ne = jt || Ot, Nt = "[object Arguments]", It = "[object Array]", Ct = "[object Boolean]", Dt = "[object Date]", Mt = "[object Error]", Rt = "[object Function]", Ft = "[object Map]", Lt = "[object Number]", Ht = "[object Object]", Gt = "[object RegExp]", zt = "[object Set]", Bt = "[object String]", Ut = "[object WeakMap]", Kt = "[object ArrayBuffer]", Vt = "[object DataView]", qt = "[object Float32Array]", Xt = "[object Float64Array]", Wt = "[object Int8Array]", Jt = "[object Int16Array]", Yt = "[object Int32Array]", Zt = "[object Uint8Array]", Qt = "[object Uint8ClampedArray]", kt = "[object Uint16Array]", er = "[object Uint32Array]", f = {};
f[qt] = f[Xt] = f[Wt] = f[Jt] = f[Yt] = f[Zt] = f[Qt] = f[kt] = f[er] = !0;
f[Nt] = f[It] = f[Kt] = f[Ct] = f[Vt] = f[Dt] = f[Mt] = f[Rt] = f[Ft] = f[Lt] = f[Ht] = f[Gt] = f[zt] = f[Bt] = f[Ut] = !1;
function tr(e) {
  return L(e) && He(e.length) && !!f[B(e)];
}
function rr(e) {
  return function(t) {
    return e(t);
  };
}
var Be = typeof exports == "object" && exports && !exports.nodeType && exports, R = Be && typeof module == "object" && module && !module.nodeType && module, nr = R && R.exports === Be, Q = nr && ke.process, Ae = function() {
  try {
    var e = R && R.require && R.require("util").types;
    return e || Q && Q.binding && Q.binding("util");
  } catch {
  }
}(), Te = Ae && Ae.isTypedArray, Ue = Te ? rr(Te) : tr, ar = Object.prototype, ir = ar.hasOwnProperty;
function sr(e, t) {
  var r = V(e), n = !r && Et(e), i = !r && !n && ne(e), a = !r && !n && !i && Ue(e), s = r || n || i || a, u = s ? xt(e.length, String) : [], o = u.length;
  for (var l in e)
    ir.call(e, l) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    vt(l, o))) && u.push(l);
  return u;
}
function or(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ur = or(Object.keys, Object), lr = Object.prototype, fr = lr.hasOwnProperty;
function cr(e) {
  if (!Tt(e))
    return ur(e);
  var t = [];
  for (var r in Object(e))
    fr.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function dr(e) {
  return mt(e) ? sr(e) : cr(e);
}
var H = N(Object, "create");
function pr() {
  this.__data__ = H ? H(null) : {}, this.size = 0;
}
function gr(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var hr = "__lodash_hash_undefined__", _r = Object.prototype, yr = _r.hasOwnProperty;
function vr(e) {
  var t = this.__data__;
  if (H) {
    var r = t[e];
    return r === hr ? void 0 : r;
  }
  return yr.call(t, e) ? t[e] : void 0;
}
var br = Object.prototype, mr = br.hasOwnProperty;
function Ar(e) {
  var t = this.__data__;
  return H ? t[e] !== void 0 : mr.call(t, e);
}
var Tr = "__lodash_hash_undefined__";
function xr(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = H && t === void 0 ? Tr : t, this;
}
function E(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
E.prototype.clear = pr;
E.prototype.delete = gr;
E.prototype.get = vr;
E.prototype.has = Ar;
E.prototype.set = xr;
function wr() {
  this.__data__ = [], this.size = 0;
}
function X(e, t) {
  for (var r = e.length; r--; )
    if (Le(e[r][0], t))
      return r;
  return -1;
}
var Sr = Array.prototype, $r = Sr.splice;
function Er(e) {
  var t = this.__data__, r = X(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : $r.call(t, r, 1), --this.size, !0;
}
function Or(e) {
  var t = this.__data__, r = X(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Pr(e) {
  return X(this.__data__, e) > -1;
}
function jr(e, t) {
  var r = this.__data__, n = X(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function A(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
A.prototype.clear = wr;
A.prototype.delete = Er;
A.prototype.get = Or;
A.prototype.has = Pr;
A.prototype.set = jr;
var G = N(w, "Map");
function Nr() {
  this.size = 0, this.__data__ = {
    hash: new E(),
    map: new (G || A)(),
    string: new E()
  };
}
function Ir(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function W(e, t) {
  var r = e.__data__;
  return Ir(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Cr(e) {
  var t = W(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Dr(e) {
  return W(this, e).get(e);
}
function Mr(e) {
  return W(this, e).has(e);
}
function Rr(e, t) {
  var r = W(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function P(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
P.prototype.clear = Nr;
P.prototype.delete = Cr;
P.prototype.get = Dr;
P.prototype.has = Mr;
P.prototype.set = Rr;
function Fr(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
function Lr() {
  this.__data__ = new A(), this.size = 0;
}
function Hr(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Gr(e) {
  return this.__data__.get(e);
}
function zr(e) {
  return this.__data__.has(e);
}
var Br = 200;
function Ur(e, t) {
  var r = this.__data__;
  if (r instanceof A) {
    var n = r.__data__;
    if (!G || n.length < Br - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new P(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function x(e) {
  var t = this.__data__ = new A(e);
  this.size = t.size;
}
x.prototype.clear = Lr;
x.prototype.delete = Hr;
x.prototype.get = Gr;
x.prototype.has = zr;
x.prototype.set = Ur;
function Kr(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, a = []; ++r < n; ) {
    var s = e[r];
    t(s, r, e) && (a[i++] = s);
  }
  return a;
}
function Vr() {
  return [];
}
var qr = Object.prototype, Xr = qr.propertyIsEnumerable, xe = Object.getOwnPropertySymbols, Wr = xe ? function(e) {
  return e == null ? [] : (e = Object(e), Kr(xe(e), function(t) {
    return Xr.call(e, t);
  }));
} : Vr;
function Jr(e, t, r) {
  var n = t(e);
  return V(e) ? n : Fr(n, r(e));
}
function we(e) {
  return Jr(e, dr, Wr);
}
var ae = N(w, "DataView"), ie = N(w, "Promise"), se = N(w, "Set"), Se = "[object Map]", Yr = "[object Object]", $e = "[object Promise]", Ee = "[object Set]", Oe = "[object WeakMap]", Pe = "[object DataView]", Zr = O(ae), Qr = O(G), kr = O(ie), en = O(se), tn = O(re), T = B;
(ae && T(new ae(new ArrayBuffer(1))) != Pe || G && T(new G()) != Se || ie && T(ie.resolve()) != $e || se && T(new se()) != Ee || re && T(new re()) != Oe) && (T = function(e) {
  var t = B(e), r = t == Yr ? e.constructor : void 0, n = r ? O(r) : "";
  if (n)
    switch (n) {
      case Zr:
        return Pe;
      case Qr:
        return Se;
      case kr:
        return $e;
      case en:
        return Ee;
      case tn:
        return Oe;
    }
  return t;
});
var je = w.Uint8Array, rn = "__lodash_hash_undefined__";
function nn(e) {
  return this.__data__.set(e, rn), this;
}
function an(e) {
  return this.__data__.has(e);
}
function q(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new P(); ++t < r; )
    this.add(e[t]);
}
q.prototype.add = q.prototype.push = nn;
q.prototype.has = an;
function sn(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function on(e, t) {
  return e.has(t);
}
var un = 1, ln = 2;
function Ke(e, t, r, n, i, a) {
  var s = r & un, u = e.length, o = t.length;
  if (u != o && !(s && o > u))
    return !1;
  var l = a.get(e), _ = a.get(t);
  if (l && _)
    return l == t && _ == e;
  var c = -1, d = !0, y = r & ln ? new q() : void 0;
  for (a.set(e, t), a.set(t, e); ++c < u; ) {
    var g = e[c], h = t[c];
    if (n)
      var v = s ? n(h, g, c, t, e, a) : n(g, h, c, e, t, a);
    if (v !== void 0) {
      if (v)
        continue;
      d = !1;
      break;
    }
    if (y) {
      if (!sn(t, function(p, b) {
        if (!on(y, b) && (g === p || i(g, p, r, n, a)))
          return y.push(b);
      })) {
        d = !1;
        break;
      }
    } else if (!(g === h || i(g, h, r, n, a))) {
      d = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), d;
}
function fn(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function cn(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var dn = 1, pn = 2, gn = "[object Boolean]", hn = "[object Date]", _n = "[object Error]", yn = "[object Map]", vn = "[object Number]", bn = "[object RegExp]", mn = "[object Set]", An = "[object String]", Tn = "[object Symbol]", xn = "[object ArrayBuffer]", wn = "[object DataView]", Ne = _e ? _e.prototype : void 0, k = Ne ? Ne.valueOf : void 0;
function Sn(e, t, r, n, i, a, s) {
  switch (r) {
    case wn:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case xn:
      return !(e.byteLength != t.byteLength || !a(new je(e), new je(t)));
    case gn:
    case hn:
    case vn:
      return Le(+e, +t);
    case _n:
      return e.name == t.name && e.message == t.message;
    case bn:
    case An:
      return e == t + "";
    case yn:
      var u = fn;
    case mn:
      var o = n & dn;
      if (u || (u = cn), e.size != t.size && !o)
        return !1;
      var l = s.get(e);
      if (l)
        return l == t;
      n |= pn, s.set(e, t);
      var _ = Ke(u(e), u(t), n, i, a, s);
      return s.delete(e), _;
    case Tn:
      if (k)
        return k.call(e) == k.call(t);
  }
  return !1;
}
var $n = 1, En = Object.prototype, On = En.hasOwnProperty;
function Pn(e, t, r, n, i, a) {
  var s = r & $n, u = we(e), o = u.length, l = we(t), _ = l.length;
  if (o != _ && !s)
    return !1;
  for (var c = o; c--; ) {
    var d = u[c];
    if (!(s ? d in t : On.call(t, d)))
      return !1;
  }
  var y = a.get(e), g = a.get(t);
  if (y && g)
    return y == t && g == e;
  var h = !0;
  a.set(e, t), a.set(t, e);
  for (var v = s; ++c < o; ) {
    d = u[c];
    var p = e[d], b = t[d];
    if (n)
      var I = s ? n(b, p, d, t, e, a) : n(p, b, d, e, t, a);
    if (!(I === void 0 ? p === b || i(p, b, r, n, a) : I)) {
      h = !1;
      break;
    }
    v || (v = d == "constructor");
  }
  if (h && !v) {
    var S = e.constructor, j = t.constructor;
    S != j && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof j == "function" && j instanceof j) && (h = !1);
  }
  return a.delete(e), a.delete(t), h;
}
var jn = 1, Ie = "[object Arguments]", Ce = "[object Array]", U = "[object Object]", Nn = Object.prototype, De = Nn.hasOwnProperty;
function In(e, t, r, n, i, a) {
  var s = V(e), u = V(t), o = s ? Ce : T(e), l = u ? Ce : T(t);
  o = o == Ie ? U : o, l = l == Ie ? U : l;
  var _ = o == U, c = l == U, d = o == l;
  if (d && ne(e)) {
    if (!ne(t))
      return !1;
    s = !0, _ = !1;
  }
  if (d && !_)
    return a || (a = new x()), s || Ue(e) ? Ke(e, t, r, n, i, a) : Sn(e, t, o, r, n, i, a);
  if (!(r & jn)) {
    var y = _ && De.call(e, "__wrapped__"), g = c && De.call(t, "__wrapped__");
    if (y || g) {
      var h = y ? e.value() : e, v = g ? t.value() : t;
      return a || (a = new x()), i(h, v, r, n, a);
    }
  }
  return d ? (a || (a = new x()), Pn(e, t, r, n, i, a)) : !1;
}
function Ve(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !L(e) && !L(t) ? e !== e && t !== t : In(e, t, r, n, Ve, i);
}
function Cn(e, t) {
  return Ve(e, t);
}
const Dn = Ze(
  [
    "max-h-[340px] block min-h-72 w-full resize-none overflow-y-auto placeholder:text-text-neutral-medium disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak typography-body-14-regular-multiline border border-solid relative border-line-neutral-weak3 rounded-12 px-16 py-12"
  ],
  {
    variants: {
      isFocused: {
        true: "border px-15 py-11",
        false: ""
      },
      // 읽기 전용은 글자색이 달라지고 캐럿을 감춘다. 두 값이 함께 나가지 않도록 base 에서 글자색을 뺐다.
      // 배경은 disabled 와 값이 같아 호출부에서 하나로 계산한다.
      isReadOnly: {
        true: "text-text-neutral-sub caret-transparent",
        false: "text-text-neutral-main"
      }
    },
    defaultVariants: {
      isFocused: !1,
      isReadOnly: !1
    }
  }
), oe = 340, Mn = 21, Rn = 24, Fn = (e) => {
  const t = Math.min(e, oe) - Rn;
  return Math.floor(t / Mn);
}, fe = z(
  ({
    maxHeight: e = oe,
    disabled: t,
    hasError: r,
    defaultValue: n,
    maxLength: i,
    id: a,
    value: s,
    onChange: u,
    isReadOnly: o = !1,
    ...l
  }, _) => {
    e > oe && process.env.NODE_ENV === "development" && console.warn("maxHeight: maxHeight must be less than or equal to 340.");
    const [c, d] = M(null);
    te(() => {
      import("./react-textarea-autosize.browser.esm-B2yGxKRM.mjs").then(($) => {
        d(() => $.default);
      });
    }, []);
    const [y, g] = M(null), h = D(() => ({ current: y }), [y]), { isFocused: v } = Qe(h), p = s !== void 0, [b, I] = M(n || ""), S = p ? s : b, j = D(() => Math.max(1, Fn(e)), [e]), ce = D(() => t ? "border-line-neutral-weak3" : o ? "border-line-neutral-weak3 focus-visible:border-line-neutral-main" : r ? "border-line-danger-main caret-text-danger-main" : v ? "border-line-primary-main caret-fill-primary-main" : "border-line-neutral-weak3", [t, o, r, v]), de = t || o ? "bg-fill-neutral-weak" : "bg-static-white", pe = Dn({ isFocused: o ? !1 : v, isReadOnly: o }), ge = D(() => Ye([
      ($) => {
        g($);
      },
      _
    ]), [_]), he = ue(
      ($) => {
        let { value: C } = $.target;
        i && C.length > i && (C = C.slice(0, i), $.target.value = C), p || I(C), u == null || u($);
      },
      [p, i, u]
    );
    return te(() => {
      p && I(S);
    }, [p, S]), c ? /* @__PURE__ */ m(
      c,
      {
        className: F(pe, de, ce),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        maxRows: j,
        name: "textField",
        onChange: he,
        readOnly: o,
        ref: ge,
        value: p ? s : b,
        ...l
      }
    ) : /* @__PURE__ */ m(
      "textarea",
      {
        className: F(pe, de, ce),
        defaultValue: p ? void 0 : n,
        disabled: t,
        id: a,
        maxLength: i,
        name: "textField",
        onChange: he,
        readOnly: o,
        ref: ge,
        value: p ? s : b,
        ...l
      }
    );
  }
);
fe.displayName = "NDS.BaseTextArea";
const J = z(({ children: e, ...t }, r) => /* @__PURE__ */ m("label", { ref: r, ...t, className: "flex-start flex w-full px-4", children: typeof e == "string" ? /* @__PURE__ */ m("span", { className: "line-clamp-1 text-text-neutral-main typography-body-13-semibold", children: e }) : e }));
J.displayName = "NDS.Label";
le(J, Cn);
const Y = ({
  leftContent: e,
  leftContentClassName: t,
  currentLength: r,
  maxLength: n,
  hasError: i,
  disabled: a,
  isReadOnly: s
}) => {
  const u = D(() => a ? "text-interaction-neutral-disable-main" : i ? "text-text-danger-main" : s ? "text-text-neutral-sub" : "text-text-neutral-main", [a, i, s]);
  return /* @__PURE__ */ K("div", { className: "flex w-full justify-between px-4 text-left", children: [
    e ? /* @__PURE__ */ m("div", { className: F("mr-8 line-clamp-2 typography-body-12-regular", u, t), children: e }) : null,
    !a && n !== void 0 && r !== void 0 ? /* @__PURE__ */ K("div", { className: "ml-auto typography-body-12-regular", children: [
      /* @__PURE__ */ m("span", { className: "font-bold", children: r.toLocaleString() }),
      "/",
      n.toLocaleString()
    ] }) : null
  ] });
};
Y.displayName = "NDS.SupportText";
le(Y);
const qe = z(
  ({ label: e, supportLeftContent: t, onChange: r, className: n, textAreaRef: i, ...a }, s) => {
    const u = Me(null);
    Je(s, () => u.current);
    const o = ue(
      (l) => {
        r == null || r(l);
      },
      [r]
    );
    return /* @__PURE__ */ K("div", { className: F("flex w-full flex-col gap-8", n), ref: u, children: [
      e ? /* @__PURE__ */ m(J, { htmlFor: a.id, children: e }) : null,
      /* @__PURE__ */ m(fe, { onChange: o, ref: i, ...a }),
      t ? /* @__PURE__ */ m(
        Y,
        {
          disabled: a.disabled,
          hasError: a.hasError,
          isReadOnly: a.isReadOnly,
          leftContent: t
        }
      ) : null
    ] });
  }
);
qe.displayName = "NDS.DefaultTextArea";
const ee = (e) => typeof e == "string" ? e : typeof e == "number" ? e.toString() : Array.isArray(e) ? e.join(",") : "", Xe = z(
  ({ label: e, supportLeftContent: t, maxLength: r, value: n, defaultValue: i, onChange: a, className: s, textAreaRef: u, ...o }, l) => {
    const _ = Me(null), c = n !== void 0, [d, y] = M(ee(n ?? i ?? "")), [g, h] = M(d.length), v = ue(
      (p) => {
        const { value: b } = p.target;
        c || y(b), a == null || a(p), h(b.length);
      },
      [a, c]
    );
    return te(() => {
      c && h(ee(n).length);
    }, [c, n]), /* @__PURE__ */ K("div", { className: F("flex w-full flex-col gap-8", s), ref: _, children: [
      e ? /* @__PURE__ */ m(J, { htmlFor: o.id, children: e }) : null,
      /* @__PURE__ */ m(
        fe,
        {
          defaultValue: c ? void 0 : i,
          maxLength: r,
          onChange: v,
          ref: u,
          value: c ? ee(n) : void 0,
          ...o
        }
      ),
      /* @__PURE__ */ m(
        Y,
        {
          currentLength: g,
          disabled: o.disabled,
          hasError: o.hasError,
          leftContent: t,
          maxLength: r
        }
      )
    ] });
  }
);
Xe.displayName = "NDS.NeedsCharCountTextArea";
const We = z(
  ({ maxLength: e, hasError: t, isReadOnly: r, ...n }, i) => {
    const a = r ? !1 : t;
    return e === void 0 || r ? /* @__PURE__ */ m(qe, { hasError: a, isReadOnly: r, ref: i, ...n }) : /* @__PURE__ */ m(
      Xe,
      {
        hasError: a,
        isReadOnly: r,
        maxLength: e,
        ref: i,
        ...n
      }
    );
  }
);
We.displayName = "NDS.TextArea";
le(We);
export {
  We as T
};
